
import GwPageContainer from '~/patterns/molecules/page-container/page-container';
import GwAvatar from '~/patterns/atoms/avatar/avatar.vue';
import GwIcon from '~/patterns/atoms/icon/icon.vue';

export default {
    components: {
        GwPageContainer,
        GwAvatar,
        GwIcon
    },
    props: {
        contact: {
            type: Object,
            default: () => { return {}; }
        }
    }
};
